import { render, staticRenderFns } from "./ExternalTicket.vue?vue&type=template&id=15215ad0"
import script from "./ExternalTicket.vue?vue&type=script&lang=js"
export * from "./ExternalTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports